import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // Timeline Menu
  nativeCommsMessageTypes.REMOVE_FROM_VIEW,
  // View Menu
  nativeCommsMessageTypes.EXPAND_PARENT_ITEM,
  nativeCommsMessageTypes.COLLAPSE_PARENT_ITEM
];
